import { atom, withInit } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'

export type NavigationLocked = 'expanded' | 'collapsed' | undefined

export const navigationLockedAtom = atom<NavigationLocked>(
  'collapsed',
  'navigationLockedAtom',
).pipe(
  withLocalStorage({
    key: `${STORAGE_PREFIX}/navigationExpansionLocked`,
  }),
)

export const navigationExpandedAtom = atom(
  false,
  'navigationExpandedAtom',
).pipe(withInit((ctx) => ctx.get(navigationLockedAtom) === 'expanded'))
